export const dadosSequenciaisStyles = {}
